import { upperFirst } from 'lodash-es'

import { listSentence } from '@/lib/formatters'
import { IntakeKind } from '@/models/fillApplication'

const INTAKE_KIND_LABELS: Record<IntakeKind, string> = {
  [IntakeKind.LOSS_RUN]: 'loss run',
  [IntakeKind.POLICY]: 'policy',
  [IntakeKind.COI]: 'certificate of insurance',
  [IntakeKind.DRIVER_LIST]: 'driver list',
  [IntakeKind.EQUIPMENT_LIST]: 'truck and trailer list',
  [IntakeKind.MVR]: 'MVR',
  [IntakeKind.IFTA]: 'IFTA report',
  [IntakeKind.OTHER]: 'other document',
}

/** "Loss run and policy" */
export function kindsSentence(kinds: IntakeKind[]): string {
  return upperFirst(
    listSentence(kinds.map((kind) => (INTAKE_KIND_LABELS as Partial<Record<string, string>>)[kind] ?? kind))
  )
}
